import { useDocumentData } from "react-firebase-hooks/firestore";
import { db } from "@poseidon/firebase/firebase";

import { doc } from "firebase/firestore";
import { getDate } from "@poseidon/firebase/timestamp";

export const useApplication = (applicationId) => {
  const [application, application_loading, application_error] = useDocumentData(
    doc(db, "applications", applicationId),
    {
      snapshotListenOptions: { includeMetadataChanges: true },
    }
  );
  const [dealer, dealer_loading, dealer_error] = useDocumentData(
    application?.dealer
  );
  const [applicantDoc, applicant_loading, applicant_error] = useDocumentData(
    application?.applicants?.at(0)
  );
  const [jointApplicantDoc, jointApplicant_loading, jointApplicant_error] =
    useDocumentData(application?.applicants?.at(1));
  const [vessel, vessel_loading, vessel_error] = useDocumentData(
    application?.vessel
  );
  const loading =
    application_loading ||
    dealer_loading ||
    applicant_loading ||
    jointApplicant_loading ||
    vessel_loading;
  const error =
    application_error ||
    dealer_error ||
    applicant_error ||
    jointApplicant_error ||
    vessel_error;

  const applicant = applicantDoc
    ? {
        isJoint: false,
        sailor: { id: application.applicants?.at(0)?.id, ...applicantDoc },
      }
    : undefined;

  const jointApplicant = jointApplicantDoc
    ? {
        isJoint: true,
        sailor: { id: application.applicants?.at(1)?.id, ...jointApplicantDoc },
      }
    : undefined;

  const combined =
    !loading && application && applicant
      ? {
          id: applicationId,
          ...mapApplicationSimple(application),
          applicant,
          jointApplicant,
          dealer: dealer
            ? { id: application.dealer?.id, ...dealer }
            : undefined,
          applicants: [applicant, jointApplicant].filter((v) => !!v),
          vessel: vessel
            ? { id: application.vessel?.id, ...vessel }
            : undefined,
        }
      : undefined;
  return {
    application: combined,
    loading,
    error,
  };
};

const mapApplicationSimple = (application) => {
  return {
    ...application,
    completionDate: getDate(application.completionDate),
    createdAt: getDate(application.createdAt),
    updatedAt: getDate(application.updatedAt),
    isJoint: !!application.isJoint,
    lock_personalDetails: !!application.lock_personalDetails,
    lock_sailor: !!application.lock_sailor,
    lock_dealer: !!application.lock_dealer,
  };
};
